import { Module } from "vuex";
import { ISabreSegmentState } from "@/core/interfaces/sabreSegmentState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const sabreSegmentModule: Module<ISabreSegmentState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default sabreSegmentModule;
